var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.additionalInfo.length
    ? _c(
        "div",
        {
          staticClass: "preview__section",
          attrs: { id: "additionalImportant-info" },
        },
        [
          _c("h3", { staticClass: "preview__title" }, [
            _vm._v(
              "\n    " + _vm._s(_vm.translations.textAInformation.text) + "\n  "
            ),
          ]),
          _vm.tourAdditional.more
            ? [
                _vm._l(_vm.tourAdditional.start, function (additional) {
                  return _c(
                    "div",
                    {
                      key: `additional-${additional.id}`,
                      staticClass: "preview__include",
                    },
                    [
                      _c("div", {
                        staticClass: "preview__dot preview__dot--orange",
                      }),
                      _c("span", { staticClass: "preview__include-text" }, [
                        _vm._v(_vm._s(additional.content)),
                      ]),
                    ]
                  )
                }),
                !_vm.showTourAdditional
                  ? _c(
                      "span",
                      {
                        staticClass: "preview__read-more",
                        on: {
                          click: function ($event) {
                            _vm.showTourAdditional = true
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.translations.textReadMore.text))]
                    )
                  : _vm._e(),
                _vm.showTourAdditional
                  ? [
                      _vm._l(_vm.tourAdditional.more, function (additional) {
                        return _c(
                          "div",
                          {
                            key: `additional-${additional.id}`,
                            staticClass: "preview__include",
                          },
                          [
                            _c("div", {
                              staticClass: "preview__dot preview__dot--orange",
                            }),
                            _c(
                              "span",
                              { staticClass: "preview__include-text" },
                              [_vm._v(_vm._s(additional.content))]
                            ),
                          ]
                        )
                      }),
                      _c(
                        "span",
                        {
                          staticClass: "preview__read-more",
                          on: {
                            click: function ($event) {
                              _vm.showTourAdditional = false
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.translations.textHide.text))]
                      ),
                    ]
                  : _vm._e(),
              ]
            : _vm._l(_vm.tourAdditional, function (additional) {
                return _c(
                  "div",
                  {
                    key: `additional-${additional.id}`,
                    staticClass: "preview__include",
                  },
                  [
                    _c("div", {
                      staticClass: "preview__dot preview__dot--orange",
                    }),
                    _c("span", { staticClass: "preview__include-text" }, [
                      _vm._v(_vm._s(additional.content)),
                    ]),
                  ]
                )
              }),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }